import he from 'he';
import { pageLayouts } from '../constants';
import { cpdTeamActivityReport } from '../reports';
import { downloadBlobStreamFile, getBlobStream, getPdfStream, writeDataToPdfStream } from '../utils';

const exportTeamCpdReportPdf = ({
  afsl,
  business,
  businessTeamsWithStats,
  totalTeamProgressRows,
  TeamsReportStats,
  filter: {
    fromDate,
    toDate
  },
  defaultProgressLabel
}) => {
  downloadBlobStreamFile(writeDataToPdfStream(getPdfStream({
    layout: pageLayouts.landscape,
    size: 'A4'
  }), cpdTeamActivityReport({
    pageLayout: pageLayouts.landscape,
    pageSize: 'A4',
    reportee: business.name,
    afsl: afsl,
    businessTeamsWithStats,
    totalTeamProgressRows,
    TeamsReportStats,
    minDate: fromDate,
    maxDate: toDate,
    defaultProgressLabel
  })).pipe(getBlobStream()), `business-cpd-activity-${he.decode(business.name)}.pdf`)
}

export default exportTeamCpdReportPdf


// WEBPACK FOOTER //
// ./src/reports/export-team-cpd-report-pdf.js